'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = require('../../../utils/logger')('splitio-storage:localstorage');

var DEFINED = '1';

var SegmentCacheInLocalStorage = function () {
  function SegmentCacheInLocalStorage(keys) {
    (0, _classCallCheck3.default)(this, SegmentCacheInLocalStorage);

    this.keys = keys;
  }

  (0, _createClass3.default)(SegmentCacheInLocalStorage, [{
    key: 'addToSegment',
    value: function addToSegment(segmentName /*, segmentKeys: Array<string>*/) {
      var segmentKey = this.keys.buildSegmentNameKey(segmentName);

      try {
        localStorage.setItem(segmentKey, DEFINED);
        return true;
      } catch (e) {
        log.error(e);
        return false;
      }
    }
  }, {
    key: 'removeFromSegment',
    value: function removeFromSegment(segmentName /*, segmentKeys: Array<string>*/) {
      var segmentKey = this.keys.buildSegmentNameKey(segmentName);

      try {
        localStorage.removeItem(segmentKey);
        return true;
      } catch (e) {
        log.error(e);
        return false;
      }
    }
  }, {
    key: 'resetSegments',
    value: function resetSegments(segmentNames) {
      var _this = this;

      var isDiff = false;
      var index = void 0;

      // Scan current values from localStorage
      var storedSegmentNames = (0, _keys2.default)(localStorage).reduce(function (accum, key) {
        var segmentName = _this.keys.extractSegmentName(key);

        if (segmentName) accum.push(segmentName);

        return accum;
      }, []);

      // Extreme fast => everything is empty
      if (segmentNames.length === 0 && storedSegmentNames.length === segmentNames.length) return isDiff;

      // Quick path
      if (storedSegmentNames.length !== segmentNames.length) {
        isDiff = true;

        storedSegmentNames.forEach(function (segmentName) {
          return _this.removeFromSegment(segmentName);
        });
        segmentNames.forEach(function (segmentName) {
          return _this.addToSegment(segmentName);
        });
      } else {
        // Slowest path => we need to find at least 1 difference because
        for (index = 0; index < segmentNames.length && storedSegmentNames.indexOf(segmentNames[index]) !== -1; index++) {}

        if (index < segmentNames.length) {
          isDiff = true;

          storedSegmentNames.forEach(function (segmentName) {
            return _this.removeFromSegment(segmentName);
          });
          segmentNames.forEach(function (segmentName) {
            return _this.addToSegment(segmentName);
          });
        }
      }

      return isDiff;
    }
  }, {
    key: 'isInSegment',
    value: function isInSegment(segmentName /*, key: string*/) {
      return localStorage.getItem(this.keys.buildSegmentNameKey(segmentName)) === DEFINED;
    }
  }, {
    key: 'setChangeNumber',
    value: function setChangeNumber() {
      return true;
    }
  }, {
    key: 'getChangeNumber',
    value: function getChangeNumber() {
      return -1;
    }
  }, {
    key: 'registerSegment',
    value: function registerSegment() {
      return false;
    }
  }, {
    key: 'registerSegments',
    value: function registerSegments() {
      return false;
    }
  }, {
    key: 'getRegisteredSegments',
    value: function getRegisteredSegments() {
      return [];
    }
  }, {
    key: 'flush',
    value: function flush() {
      log.info('Flushing localStorage');
      localStorage.clear();
    }
  }]);
  return SegmentCacheInLocalStorage;
}();

module.exports = SegmentCacheInLocalStorage;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/storage/SegmentCache/InLocalStorage/index.js
// module id = 722
// module chunks = 10